<template>
<main class="main-wrapper flex-grow-1">
	<div class="d-flex align-items-center bg-white">
		<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
			{{this.$t('460') }}
		</div>
	</div>
	<div class="divider"></div>
	<!-- subtabs -->

	<div class="container container--narrow mgt-50">
		<div class="t-headline7  font-m">{{$t('468')}}</div>
				<div class="payment-options mgt-16 mgb-24" >
					<div v-for="(method, index) in paymentMethodList" :key="index" >
						<div class="pdl-16 h-46 mgb-8 pdr-14 b-radius4 d-flex align-items-center option cursor-pointer" 	
						:class="{'selected': paymentMethod === method.moduleName}" 
							@click="setPaymentMethod(method.moduleName)" @keypress="setPaymentMethod(method.moduleName)"  tabindex="0"
							v-if="method.moduleName === 'bank_transfer' || method.moduleName === 'paypal'  || method.moduleName === 'dummy'"
							>
							<div class="t-body1 flex-grow-1 font-r" v-if="method.moduleName === 'paypal'">
								{{$t('470')}}
							</div>
							<div class="t-body1 flex-grow-1 font-r" v-else-if="method.moduleName === 'bank_transfer'">
								{{$t('471')}}
							</div>
							<div class="t-body1 flex-grow-1 font-r" v-else-if="method.moduleName === 'dummy'">
								{{method.moduleName}}
							</div>
							<i class="material-icons t-headline9 t-weight800" v-if="paymentMethod === method.moduleName">check</i>
						</div>
					</div>
					</div>
					<div class="mgb-16" v-if="paymentMethod">
						<!-- <div class="divider"></div> -->
						<div v-if="paymentMethod === 'bank_transfer'">
							<div class="mgt-24 t-body3 font-r">	{{$t('518')}}</div>
							<div class="mgt-16">
								<label class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46"
									data-mdc-auto-init="MDCTextField" id="depositorNameEl" style="cursor: pointer">
									<span class="mdc-notched-outline">
										<span class="mdc-notched-outline__leading"></span>
										<span class="mdc-notched-outline__notch">
											<span class="mdc-floating-label" id="password-message">{{$t('519')}}</span>
										</span>
										<span class="mdc-notched-outline__trailing"></span>
									</span>
									<input class="mdc-text-field__input" type="text"
											maxlength="50" 
											autocomplete="off"
											v-model="depositorName"
											id="depositorName"
											v-validate="'required'" />
									<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
													role="button"></i>
								</label>
								<div class="mdc-text-field-helper-line d-block">
									<div class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r ">
										{{$t('520')}}
									</div>
								</div>
							</div>
						</div>
				<!-- <div v-if="paymentMethod === 'paypal'">
					<div class="mgt-24 t-body3 font-r">	{{$t('472')}}</div>
					<div class="mgt-16">
						<div class="first-item">
							<div class="mdc-form-field">
								<div class="mdc-radio radio-red">
									<input class="mdc-radio__native-control" type="radio" 
										v-model="creditcardId"
										id="creditcard"
										value="account"
										name="creditcard"
									>
									<div class="mdc-radio__background">
										<div class="mdc-radio__outer-circle"></div>
										<div class="mdc-radio__inner-circle"></div>
									</div>
								</div>
								<label for="creditcard" class="t-subtitle3 l-spacing48 font-m t-line-h-24">
									{{$t('469')}}
								</label>
							</div>
						</div>

						<div class="mgt-16 d-flex justify-content-between align-items-center" v-for="(creditcard, index) in creditcardList" :key="index">
							<div class="mdc-form-field">
								<div class="mdc-radio radio-red">
									<input class="mdc-radio__native-control" type="radio" 
										v-model="creditcardId"
										:value="creditcard.id"
										name="creditcard"
										:id="`creditcard${creditcard.id}`"
									>
									<div class="mdc-radio__background">
										<div class="mdc-radio__outer-circle"></div>
										<div class="mdc-radio__inner-circle"></div>
									</div>
								</div>
								<label :for="`creditcard${creditcard.id}`" class="t-subtitle3 l-spacing48 font-m t-line-h-24">{{creditcard.cardNumber}}</label>
							</div>
							<div>
								 <button class="mdc-button bg-secondaryBtn t-color-secondaryBtnText" @click="deleteCreditCard(creditcard.id)">
									<div class="mdc-button__ripple"></div>
											<span class="mdc-button__label t-body2 font-r">{{$t('882')}}</span>
								</button>
							</div>
						</div>
						
						<div class="mgt-16 t-body1 d-flex align-items-center" @click="toggleAddCardForm()">
							<div class="w-40 t-center t-color-gray6 align-self-center t-line-h-0">
								<i class="material-icons">add_circle_outline</i>
							</div>
							<div class="mgr-20 mgl-20 align-self-center">
								{{$t('473')}}
							</div>
						</div>
						<add-credit-card v-if="isAddCardForm" @toggleAddCardForm="toggleAddCardForm" @fatchCreditCard="fatchCreditCard"/>
					</div>
				</div> -->
					</div>
				</div>
			<div class="divider"></div>
			<div class="bg-documentGray" v-if="orderData">
				<div class="container container--narrow pdt-16 pdb-16">
					<div class="t-headline7 t-line-h-33 font-m mgb-8">{{$t('474')}}</div>
					<div class="h-48 d-flex align-items-center">
						<div class="t-body3 l-spacing42 t-line-h-22 t-color-bodyGrayA font-r flex-grow-1">{{$t('475')}}</div>
						<div class="d-flex align-items-baseline">
							<div class="t-caption mgr-8 font-r">{{orderData.currency}}</div>
							<div class="t-subtitle3 font-rm">{{$n(orderData.totalPrice)}} </div>
						</div>
					</div>
					<div class="h-48 d-flex align-items-center" v-if="orderData && orderData.discountPrice>0">
						<div class="t-body3 l-spacing42 t-line-h-22 t-color-bodyGrayA font-r flex-grow-1">{{$t('477')}}</div>
						<div class="d-flex align-items-baseline">
							<div class="t-caption mgr-8 font-r">{{orderData.currency}}</div>
							<div class="t-subtitle3 font-rm">-{{$n(orderData.discountPrice)}} </div>
						</div>
					</div>
					<div class="divider_dot mgt-16 mgb-16"></div>
					<div class="mgt-16 d-flex align-items-center">
						<div class="t-body3 l-spacing42 t-line-h-22 t-color-bodyGrayA font-r flex-grow-1">{{$t('481')}}</div>
						<div class="d-flex align-items-baseline">
							<div class="t-body3 mgr-8 font-r">{{orderData.currency}}</div>
							<div class="t-headline5 font-rm">{{$n(orderData.paymentPrice)}} </div>
						</div>
					</div>
				</div>
			</div>
			<div class="divider"></div>
			<div class="container container--narrow mgt-13">
				<div class="mgl--11">
					<div class="mdc-form-field">
						<div class="mdc-checkbox">
							<input type="checkbox" class="mdc-checkbox__native-control" id="informationConsent" v-model="informationConsent" />
							<div class="mdc-checkbox__background check-red">
								<svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
									<path class="mdc-checkbox__checkmark-path" fill="none"
										d="M1.73,12.91 8.1,19.28 22.79,4.59" />
								</svg>
								<div class="mdc-checkbox__mixedmark"></div>
							</div>
							<div class="mdc-checkbox__ripple"></div>
						</div>
						<label for="informationConsent" class="t-subtitle3 l-spacing48 font-m t-line-h-24">
							{{$t('483')}}
						</label>
					</div>
				</div>
				<!-- <div class=" mgt-5 t-body4 l-spacing39 t-line-h24 font-r t-color-signBlue"  @click="showPaymentPolicy()">
					{{$t('484')}}
				</div> -->
				<div class="mgt-50">
					<!-- <PayPal class="test-payl" v-if="paymentMethod === 'paypal'"
						:amount="paymentPrice"
						currency="USD"
						:client="credentials"
						:button-style="myStyle"
						:experience="experienceOptions"
						v-on:payment-authorized="paymentAuthorized"
						v-on:payment-completed="paymentCompleted"
						v-on:payment-cancelled="paymentCancelled"
						env="sandbox"
                	>
                	</PayPal>  -->
					<!-- <button v-if="paymentMethod === 'bank_transfer'|| paymentMethod ===''"
						class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8 min-w-100" @click="callPayment()">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('485')}}</span>
					</button> -->

					<button 
						class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8 min-w-100" @click="callPayment()" @keypress="callPayment()" tabindex="0">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('485')}}</span>
					</button>


					<!-- <button
						class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8 min-w-100" @click="cancelPayment()">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">Cancel</span>
					</button> -->
					
				</div>
	   

		<!-- 결제 데이터 전송 폼 Payment data transfer form -->
		<form method="POST" action="" ref="formPayment">
			<input name="authToken" type="hidden" :value="authToken">
			<input name="paymentMethod" type="hidden" :value="paymentMethod">
			<input name="returnUrl" type="hidden" :value="returnUrl">
			<input name="ordererEmail" type="hidden" :value="ordererEmail">
			<input name="ordererPhone" type="hidden" :value="ordererPhone">
			<input name="informationConsent" type="hidden" :value="informationConsent">
			<input name="depositorName" type="hidden" :value="depositorName">
			<input name="data[deposit_account_id]" type="hidden" :value="creditcardId">
		</form>
	</div>
</main>
</template>

<script>
/**
 * 구매하기 - 결제하기 컴포넌트(sales - Make payment component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import salesApi  from '@/api/salesApi.js'
import {mapState, mapMutations} from 'vuex'
//import AddCreditCard from './AddCreditCard.vue'
//import PayPal from 'vue-paypal-checkout'

export default {
    components: {
        //'add-credit-card' : AddCreditCard,
        //PayPal
    },
    data() {
        return {
            authToken: '',    
            orderData: {},
            currency:'',
            paymentPrice:0,
            purchasedData: [],
            paymentText: '',
            paymentButtonText: '',

            orderId: '',
            paymentMethod: '',
            returnUrl: '',
            ordererEmail: '',
            ordererPhone: '',
            informationConsent: false,
            //informationConsent: true,
            depositorName: '',
            deposit_account_id: '',
            creditcardList: [],
            isAddCardForm: false,
            creditcardId: '',

            paymentMethodList: [],
            ecToken : '',
            
            ordererDataResp:'',
            fetchType:''
            
        }
    },

    mounted() {
       
        document.documentElement.style.overflow = 'auto'
        window.onscroll = null

        this.fetchType = this.$route.query.fetchType
        this.fetchData()
        this.fatchCreditCard()


        salesApi.salesOrdererRecent().then((response) => {
			//console.log('salesOrdererRecent',response)
			this.ordererDataResp = response.data.data                
			this.ordererEmail = this.ordererDataResp.email || this.sales.ordererEmail
			this.ordererPhone = this.ordererDataResp.phone || this.sales.ordererPhone
			this.depositorName = this.ordererDataResp.name || this.sales.ordererName
			if (!this.ordererEmail || !this.ordererPhone || !this.depositorName) {
				this.$router.go(-1);
				return;
			}
		}).catch((err) => {})

        const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
            let button = new MDCRipple.attachTo(el)
            return button
        })
    },

    computed: {
        ...mapState('sales',{
            sales : state => state,
        }),
    },

    updated() {
        // 수동결제 일 경우 입금자명 머티리얼 적용(In case of manual payment, depositor name material is applied)
        if (this.paymentMethod === 'bank_transfer') {
            let depositorNameEl = new MDCTextField(document.getElementById('depositorNameEl'))
            depositorNameEl.useNativeValidation = false
        }

        window.onload = function() {
            console.log('checkDom')  
        }
    },

    methods: {

       
        // 결제 데이터 생성 API 호출
        async fetchData() {
            let responseData = ''
            let params = this.setParams()
			const isMicro = this.$route.query.type && this.$route.query.type === "MICRO";
            // get sales order infomation
            try {
            const orderResult = isMicro ? await salesApi.salesMicroGoodsOrder(params) : await salesApi.salesGoodsOrder(params)
                const response = orderResult;
                this.orderData = response.data.data
                this.orderId = this.orderData.orderId
                this.currency =  this.orderData.currency
                this.paymentPrice = this.orderData.paymentPrice
                this.returnUrl = process.env.VUE_APP_PAYMENT_RETURN_HOST + `/sales/resultpaypal/${this.orderId}`
                this.authToken = localStorage.getItem('token')
                if(this.orderData.currency) {
                    salesApi.salesPaymentMethodList({'currency':this.orderData.currency}).then((response) => {
                        let paymentMethodLists = response.data.data
                        this.paymentMethodList = [...paymentMethodLists].reverse();
                         
                        for (var paymentMethods of this.paymentMethodList) {
                            if (paymentMethods.moduleName==="bank_transfer") {
                                this.setPaymentMethod('bank_transfer')
                                break;
                            } else {
                                if(paymentMethods.moduleName==='paypal'){
                                    this.setPaymentMethod('paypal')
                                    break;
                                }
                            }
                        }
                    }).catch((err) => {})
                }

                this.$parent.setTopAppBarCustom({
                    leftBtnMode: 'arrow_back',
                    rightBtnMode: '',
                    title: localStorage.getItem('brandName'),
                    leftBtnMethod: () => {
                        if(this.fetchType==='LEARN'){
                            this.$router.push({
                                name:'SalesInformation', 
                                params: {goodsid: this.$route.params.goodsid},
                                query:  {type: 'ListTotal',fetchType:'LEARN'}
                            })
                        } else {
                            this.$router.push({
                                name:'SalesInformation', 
                                params: {goodsid: this.$route.params.goodsid},
                                query:  {listType: 'total'}
                            })
                        }
                    },
                    rightBtnMethod: '',
                })
            } catch (error) {
                console.log("Cart sales order error : ", error)
            }
        },
        

        // 파라미터 설정(set parameter)
        setParams() {
            let params = {
                goodsId: this.$route.params.goodsid
            }
            return params
        },

        // 결제 요청(request payment)
        callPayment() {
            if (this.informationConsent && this.paymentMethod) {
                if (this.paymentMethod === 'paypal') {
                    let paymemtHost = process.env.VUE_APP_API_HOST
                    const fullPath = location.protocol + '//' + location.host;
                    let params = {
                        orderId: this.orderId,
                        paymentMethod: this.paymentMethod,
                        returnUrl: `${fullPath}/sales/resultpaypal`,
                        ordererEmail: this.ordererEmail,
                        ordererPhone: this.ordererPhone,
                        informationConsent: this.informationConsent,
                        depositorName: this.depositorName,
                        data: {
                            DEPOSIT_ACCOUNT_ID: ''
                        }
                    }

                    let responseData = null
                    this.$showLoading();
                    salesApi.salesRequestPayment(params).then((response) => {
                        responseData = response.data.data
                        this.ecToken = responseData.token
                        localStorage.setItem('goodsId',this.$route.params.goodsid)
                        localStorage.setItem('fetchType',this.fetchType)
                        this.$hideLoading();
                        window.location = `${responseData.href}`
                        
                    }).catch((err) => {
                        console.log("payError : ", err)
                        this.$hideLoading();
                    })
                }else if (this.paymentMethod === 'bank_transfer') {
                    if (!this.depositorName) {
                        this.$alert({
                            title: this.$t('50031'), //'TODO-정보입력 오류',
                            content: this.$t('50032'), //'TODO-입금자 이름을 입력해주세요.',
                            accept:  this.$t('50033'), //'TODO-확인',
                        }).then(() => {
                            
                        })
                        return false
                    }

                    let params = {
                        orderId: this.orderId,
                        paymentMethod: this.paymentMethod,
                        returnUrl: '',
                        ordererEmail: this.ordererEmail,
                        ordererPhone: this.ordererPhone,
                        informationConsent: this.informationConsent,
                        depositorName: this.depositorName,
                        data: {
                            DEPOSIT_ACCOUNT_ID: ''
                        }
                    }

                    let responseData = null
                    salesApi.salesRequestPayment(params).then((response) => {
                        responseData = response.data.data
                        this.moveResultBank()
                    }).catch((err) => {
                        // responseData = err.response.data.meta
                        // this.$error({content: responseData.errMsg}).then(() => {})
                    })
                }
                
            }else {
                if (this.paymentMethod === '') {
                    this.$alert({
                        content: this.$t('50034'), //'TODO-결제 수단을 선택해 주세요.',
                        accept:  this.$t('50035'), //'확인',
                    }).then(() => {
                        return
                    })
                }else if (!this.informationConsent) {
                    this.$alert({
                        content: this.$t('50036'), //'TODO-결제 정보 동의에 체크해 주세요.',
                        accept:  this.$t('50037'), //'확인',
                    }).then(() => {
                        return
                    })
                }
            }
            
            
        },

        paymentAuthorized: function (data) {
          console.log('paymentAuthorized',data);
        },
        paymentCompleted: function (data) {
            this.$showLoading();

            if(data.state=='approved'){
                let params = {
                    orderId: this.orderId,
                    paymentMethod: this.paymentMethod,
                    returnUrl: '',
                    ordererEmail: this.ordererEmail,
                    ordererPhone: this.ordererPhone,
                    informationConsent: this.informationConsent,
                    depositorName: this.depositorName,
                    data: {
                        DEPOSIT_ACCOUNT_ID: ''
                    }
                }

                let responseData = null
                salesApi.salesRequestPayment(params).then((response) => {
                    responseData = response.data.data
                    //console.log('responseData', responseData);
                    this.moveResultPayPal()
                    this.$hideLoading();
                }).catch((err) => {
                    this.$hideLoading();
                })
            } else {
                this.$hideLoading();
                this.$router.push({
                    
                    name: 'PaypalPaymentFail', 
                })
            }
            
        },
        paymentCancelled: function (data) {
          console.log('paymentCancelled',data);
        },
        

        // 결제수단 설정(set payment method)
        setPaymentMethod(method) {
            this.paymentMethod = method
            if(method === 'paypal'){
                var self = this;
                 setTimeout(function () {}, 1000);
            } else {}
            
        },

        hideLoader() {
            this.$hideLoading();
        },

        moveResultPayPal() {
            this.$router.push({
                name: 'SalesResultPaypal', 
                params: {orderId: this.orderId},
                query: {'ec': this.ecToken}
            })
        },

        // 수동결제 완료화면 이동(Manual payment completion screen move)
        moveResultBank() {
            this.$router.push({
                name: 'SalesResultBank', 
                params: {orderId: this.orderId}
            })
        },

        // 카드목록 토글(toggle card list)
        toggleAddCardForm() {
            this.isAddCardForm = !this.isAddCardForm
        },

        // 등록된 카드정보 조회 API 호출(get registed card list)
        fatchCreditCard() {
            salesApi.salesCreditcardList().then((response) => {
                this.creditcardList = response.data.data
            }).catch((err) => {
                
            })
        },

        // 카드 삭제 API 호출(delete card)
        deleteCreditCard(id) {
            this.$confirm({
                title: this.$t('877'), //등록된 카드 정보 삭제
                content: this.$t('878') +'<br>'+ this.$t('879'), //이 카드 정보를 삭제하시겠습니까? 확인을 누르면 카드 정보가 삭제됩니다.
                accept: this.$t('881'),
                cancel: this.$t('880')
            }).then(() => {
                let params = {
                    id: id
                }
                salesApi.salesCreditcardDelete(params).then((response) => {
                    this.fatchCreditCard()
                }).catch((err) => {})    
            }).catch((err) => {})
            
        },

        // 결제 정책 POPUP(Payment Policy POPUP)
        showPaymentPolicy() {
            let message = {
                title: this.$t('484'),
                contents: 'Todo-Contnets',
                //accept: '1'
            }
            this.$alert(message).then(() => {

            })
        }
    },
}
</script>

<style scoped>
	.payment-options{
    	cursor: pointer;
	}
</style>
